module.exports = __webpack_public_path__ + "static/img/wdsj1-1.15b4766.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdsj1-1.png
// module id = 38
// module chunks = 0